export default __webpack_public_path__ + "static/FAQ_EzyMedical (EV)-dff76bb9973494e7d0d57ecae4ce6daa.pdf";